import { IRemindersHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useReminders = (): IRemindersHook => {
  const { reminderStore } = useStore();
  const { reminders, loading } = reminderStore;

  useEffect(() => {
    reminderStore.getAll({
      isGarage: true,
      maxResultCount: 50,
      skipCount: 0,
    });
  }, [reminderStore]);

  return {
    reminders: Array.from(reminders.values()),
    loading,
  };
};
